// extracted by mini-css-extract-plugin
export var dropdownIcon = "_nt-6";
export var imgContainer = "_nt-3";
export var menuIcon = "_nt-5";
export var pillWrapper = "_nt-2";
export var pillsContainer = "_nt-1";
export var subscriptionCard = "_nt-0";
export var subscriptionLogo = "_nt-4";